export class AccidentAndMaternity {
    private provisionalDiagnosis: string;
    private surgicalDiagnosis: string;
    private isAccident: boolean;
    private isDeathCase: boolean;
    private isRTA: boolean;
    private reportedToPolice: boolean;
    private isSubstanceAbuse: boolean;
    private injuryDate: Date;
    private firNumber: string;
    private isMaternity: boolean;
    private deliveryDate: Date;
    private maternityG: number;
    private maternityP: number;
    private maternityL: number;
    private maternityA: number;
    private icdMapping: string;
    private pcsMapping: string;
    private cptMapping: string;
    private maternityType: string;
    private isWellBaby: boolean;

    constructor(accidentAndMaternity: any) {

        if (accidentAndMaternity.isAccident) {
            this.isAccident = accidentAndMaternity.isAccident;
        } else {
            this.isAccident = false;
        }
        if (accidentAndMaternity.isDeathCase) {
            this.isDeathCase = accidentAndMaternity.isDeathCase;
        } else {
            this.isDeathCase = false;
        }
        if (accidentAndMaternity.isMaternity) {
            this.isMaternity = accidentAndMaternity.isMaternity;
        } else {
            this.isMaternity = false;
        }
        if (accidentAndMaternity.isRTA) {
            this.isRTA = accidentAndMaternity.isRTA;
        } else {
            this.isRTA = false;
        }
        if (accidentAndMaternity.reportedToPolice) {
            this.reportedToPolice = accidentAndMaternity.reportedToPolice;
        } else {
            this.reportedToPolice = false;
        }
        if (accidentAndMaternity.isSubstanceAbuse) {
            this.isSubstanceAbuse = accidentAndMaternity.isSubstanceAbuse;
        } else {
            this.isSubstanceAbuse = false;
        }
        this.surgicalDiagnosis = accidentAndMaternity.surgicalDiagnosis;
        this.provisionalDiagnosis = accidentAndMaternity.provisionalDiagnosis;
        this.injuryDate = accidentAndMaternity.injuryDate;
        this.firNumber = accidentAndMaternity.firNumber;
        this.deliveryDate = accidentAndMaternity.deliveryDate;
        this.maternityG = accidentAndMaternity.maternityG;
        this.maternityP = accidentAndMaternity.maternityP;
        this.maternityL = accidentAndMaternity.maternityL;
        this.maternityA = accidentAndMaternity.maternityA;
        this.icdMapping = accidentAndMaternity.icdMapping;
        this.pcsMapping = accidentAndMaternity.pcsMapping;
        this.cptMapping = accidentAndMaternity.cptMapping;
        this.maternityType = accidentAndMaternity.maternityType;
        if(accidentAndMaternity.isWellBaby){
            this.isWellBaby = accidentAndMaternity.isWellBaby;
        }else{
            this.isWellBaby = false;
        }
    }


    /**
     * Getter $surgicalDiagnosis
     * @return {string}
     */
    public get $surgicalDiagnosis(): string {
        return this.surgicalDiagnosis;
    }

    /**
     * Setter $surgicalDiagnosis
     * @param {string} value
     */
    public set $surgicalDiagnosis(value: string) {
        this.surgicalDiagnosis = value;
    }

    /**
     * Getter $maternityType
     * @return {string}
     */
    public get $maternityType(): string {
        return this.maternityType;
    }

    /**
     * Getter $isWellBaby
     * @return {boolean}
     */
    public get $isWellBaby(): boolean {
        return this.isWellBaby;
    }

    /**
     * Setter $maternityType
     * @param {string} value
     */
    public set $maternityType(value: string) {
        this.maternityType = value;
    }

    /**
     * Setter $isWellBaby
     * @param {boolean} value
     */
    public set $isWellBaby(value: boolean) {
        this.isWellBaby = value;
    }

    /**
     * Getter $provisionalDiagnosis
     * @return {string}
     */
    public get $provisionalDiagnosis(): string {
        return this.provisionalDiagnosis;
    }

    /**
     * Getter $isAccident
     * @return {boolean}
     */
    public get $isAccident(): boolean {
        return this.isAccident;
    }
/**
     * Getter $isDeathCase
     * @return {boolean}
     */
    public get $isDeathCase(): boolean {
        return this.isDeathCase;
    }
    /**
     * Getter $isRTA
     * @return {boolean}
     */
    public get $isRTA(): boolean {
        return this.isRTA;
    }

    /**
     * Getter $reportedToPolice
     * @return {boolean}
     */
    public get $reportedToPolice(): boolean {
        return this.reportedToPolice;
    }

    /**
     * Getter $isSubstanceAbuse
     * @return {boolean}
     */
    public get $isSubstanceAbuse(): boolean {
        return this.isSubstanceAbuse;
    }

    /**
     * Getter $injuryDate
     * @return {Date}
     */
    public get $injuryDate(): Date {
        return this.injuryDate;
    }

    /**
     * Getter $firNumber
     * @return {string}
     */
    public get $firNumber(): string {
        return this.firNumber;
    }

    /**
     * Getter $isMaternity
     * @return {boolean}
     */
    public get $isMaternity(): boolean {
        return this.isMaternity;
    }

    /**
     * Getter $deliveryDate
     * @return {Date}
     */
    public get $deliveryDate(): Date {
        return this.deliveryDate;
    }

    /**
     * Getter $maternityG
     * @return {number}
     */
    public get $maternityG(): number {
        return this.maternityG;
    }

    /**
     * Getter $maternityP
     * @return {number}
     */
    public get $maternityP(): number {
        return this.maternityP;
    }

    /**
     * Getter $maternityL
     * @return {number}
     */
    public get $maternityL(): number {
        return this.maternityL;
    }

    /**
     * Getter $maternityA
     * @return {number}
     */
    public get $maternityA(): number {
        return this.maternityA;
    }

    /**
     * Getter $icdMapping
     * @return {string}
     */
    public get $icdMapping(): string {
        return this.icdMapping;
    }

    /**
     * Getter $pcsMapping
     * @return {string}
     */
    public get $pcsMapping(): string {
        return this.pcsMapping;
    }

    /**
     * Getter $cptMapping
     * @return {string}
     */
    public get $cptMapping(): string {
        return this.cptMapping;
    }

    /**
     * Setter $provisionalDiagnosis
     * @param {string} value
     */
    public set $provisionalDiagnosis(value: string) {
        this.provisionalDiagnosis = value;
    }

    /**
     * Setter $isAccident
     * @param {boolean} value
     */
    public set $isAccident(value: boolean) {
        this.isAccident = value;
    }

    /**
     * Setter $isDeathCase
     * @param {boolean} value
     */
    public set $isDeathCase(value: boolean) {
        this.isDeathCase = value;
    }
    /**
     * Setter $isRTA
     * @param {boolean} value
     */
    public set $isRTA(value: boolean) {
        this.isRTA = value;
    }

    /**
     * Setter $reportedToPolice
     * @param {boolean} value
     */
    public set $reportedToPolice(value: boolean) {
        this.reportedToPolice = value;
    }

    /**
     * Setter $isSubstanceAbuse
     * @param {boolean} value
     */
    public set $isSubstanceAbuse(value: boolean) {
        this.isSubstanceAbuse = value;
    }

    /**
     * Setter $injuryDate
     * @param {Date} value
     */
    public set $injuryDate(value: Date) {
        this.injuryDate = value;
    }

    /**
     * Setter $firNumber
     * @param {string} value
     */
    public set $firNumber(value: string) {
        this.firNumber = value;
    }

    /**
     * Setter $isMaternity
     * @param {boolean} value
     */
    public set $isMaternity(value: boolean) {
        this.isMaternity = value;
    }

    /**
     * Setter $deliveryDate
     * @param {Date} value
     */
    public set $deliveryDate(value: Date) {
        this.deliveryDate = value;
    }

    /**
     * Setter $maternityG
     * @param {number} value
     */
    public set $maternityG(value: number) {
        this.maternityG = value;
    }

    /**
     * Setter $maternityP
     * @param {number} value
     */
    public set $maternityP(value: number) {
        this.maternityP = value;
    }

    /**
     * Setter $maternityL
     * @param {number} value
     */
    public set $maternityL(value: number) {
        this.maternityL = value;
    }

    /**
     * Setter $maternityA
     * @param {number} value
     */
    public set $maternityA(value: number) {
        this.maternityA = value;
    }

    /**
     * Setter $icdMapping
     * @param {string} value
     */
    public set $icdMapping(value: string) {
        this.icdMapping = value;
    }

    /**
     * Setter $pcsMapping
     * @param {string} value
     */
    public set $pcsMapping(value: string) {
        this.pcsMapping = value;
    }

    /**
     * Setter $cptMapping
     * @param {string} value
     */
    public set $cptMapping(value: string) {
        this.cptMapping = value;
    }

}
